import { FlowNode } from '../flowState';
import { ServicesMap } from 'app/service/types';
import getNodeAction from './getNodeAction';

const isHookPollable = (node: FlowNode, services: ServicesMap) => {
  const action = getNodeAction(node, services) || {};
  return Boolean(action.hook_pollable);
};

export default isHookPollable;
